import { combineReducers } from "redux";
import bookingReducer from "./bookingReducer";
import accountReducer from "./accountReducer";
import couponReducer from "./couponReducer";
import usersReducer from "./usersReducer";
import productReducer from "./productReducer";
import productCategoryReducer from "./productCategoryReducer";
import taxReducer from "./taxReducer";
import blackoutReducer from "./blackoutReducer";
import waiverReducer from "./waiverReducer";
import uploadImageReducer from "./uploadImageReducer";
import productWorkflowReducer from "./productWorkflowReducer";
import inclusionsCategoryReducer from "./inclusionsCategoryReducer";
import exclusionsCategoryReducer from "./exclusionsCategoryReducer";
import guestDirectoryReducer from "./guestDirectoryReducer";
import guestDirectoryCategoryReducer from "./guestDirectoryCategoryReducer";
import reducerNotificationsEmails from "./reducerNotificationsEmails";
import reducerPricing from "./reducerPricing";
import reducerParticipantsCategory from "./reducerParticipantsCategory";
import productAccessibilityReducer from "./productAccessibilyReducer";
import permissionsReducer from "./permissionsReducer";
import subscriptionsReducer from "./subscriptionsReducer";
import currentProductReducer from "./currentProductReducer";
import extrasReducer from "./extrasReducer";
import customQuestionReducer from "./customQuestionReducer";
import healthSafetyRestrictionReducer from "./healthSafetyRestrictionReducer";
import analyticsReducer from "./analyticsReducer";
import curationsReducer from "./curationsReducer";
import reportsReducer from "./reportsReducer";
import marketingReducer from "./marketingReducer";

export default combineReducers({
  bookingReducer,
  accountReducer,
  couponReducer,
  usersReducer,
  productReducer,
  productCategoryReducer,
  taxReducer,
  blackoutReducer,
  waiverReducer,
  uploadImageReducer,
  productWorkflow: productWorkflowReducer,
  inclusionsCategoryReducer,
  exclusionsCategoryReducer,
  guestDirectoryReducer,
  guestDirectoryCategoryReducer,
  reducerNotificationsEmails,
  reducerPricing,
  reducerParticipantsCategory,
  productAccessibilityReducer,
  permissionsReducer,
  subscriptionsReducer,
  currentProductReducer,
  extrasReducer,
  customQuestionReducer,
  healthSafetyRestrictionReducer,
  analyticsReducer,
  curationsReducer,
  reportsReducer,
  marketingReducer,
});
